module.exports = __webpack_public_path__ + "static/media/timer-displayed-screen.3d190a68.png";